namespace Gamification.Gamification {
    export interface EstensioniRow {
        UserId?: number;
        TenantId?: number;
        IdEstensioni?: number;
        Nome?: string;
        Estensione?: string;
        IdTipologiaRisorsa?: number;
        IdTipologiaRisorsaNome?: string;
        IdTipologiaRisorsaDescrizione?: string;
    }

    export namespace EstensioniRow {
        export const idProperty = 'IdEstensioni';
        export const nameProperty = 'Nome';
        export const localTextPrefix = 'Gamification.Estensioni';
        export const lookupKey = 'Gamification.Estensioni';

        export function getLookup(): Q.Lookup<EstensioniRow> {
            return Q.getLookup<EstensioniRow>('Gamification.Estensioni');
        }
        export const deletePermission = 'Gamification:Prodotti';
        export const insertPermission = 'Gamification:Prodotti';
        export const readPermission = 'Gamification:Prodotti';
        export const updatePermission = 'Gamification:Prodotti';

        export declare const enum Fields {
            UserId = "UserId",
            TenantId = "TenantId",
            IdEstensioni = "IdEstensioni",
            Nome = "Nome",
            Estensione = "Estensione",
            IdTipologiaRisorsa = "IdTipologiaRisorsa",
            IdTipologiaRisorsaNome = "IdTipologiaRisorsaNome",
            IdTipologiaRisorsaDescrizione = "IdTipologiaRisorsaDescrizione"
        }
    }
}
